<template>
  <div id="user-app">
    <nav v-if="appIsActive" id="user-navigation">
      <div class="nav-wrapper-app layout-spacing-big">
        <div class="nav-container">
          <router-link class="app-link" to="/app">
            <img src="../../assets/app-icons/navigation/home.svg" alt="Početna" />
            <span>Početna</span>
          </router-link>
          <router-link class="app-link" to="/app/schedule">
            <img src="../../assets/app-icons/navigation/schedule.svg" alt="Raspored" />
            <span>Raspored</span>
            <span v-if="eventCount > 0" class="menu-schedule-number-icon">
              {{ eventCount }}
            </span>
          </router-link>
          <router-link class="app-link" to="/app/prizes" v-if="features.prizes">
            <img src="../../assets/app-icons/navigation/prizes.svg" alt="Nagradna igra" />
            <span>Nagrade</span>
          </router-link>
          <router-link class="app-link fly-talks" to="/app/fly-talks" v-if="features.flyTalks">
            <img src="../../assets/app-icons/navigation/fly-talks.svg" alt="Fly talks" />
            <span>Fly talks</span>
          </router-link>
          <router-link class="app-link profile" to="/app/profile">
            <img src="../../assets/app-icons/navigation/profile.svg" alt="Profil" />
            <span>Profil</span>
          </router-link>
        </div>
        <router-link class="navbar-logo" to="/">
          <img src="../../assets/app-icons/navigation/logo.svg" alt="Logo" />
        </router-link>
      </div>
    </nav>
    <div class="user-offline" v-if="isOffline">
      Uređaj je offline. Funkcionalnosti aplikacije su ograničene.
      <span v-on:click="isOffline = false">X</span>
    </div>
    <router-view />
  </div>
</template>

<script>
import { appIsActive } from '@/config';
import EventBus from '@/event-bus';

export default {
  name: 'UserApp',
  data() {
    return {
      appliedEvents: [],
      eventsFavorited: [],
      eventCount: 0,
      isOffline: false,
      appIsActive,
      route: 'app/navigation',
      features: {},
    };
  },
  methods: {
    handleConnection: function() {
      if (navigator.onLine) {
        this.isReachable(this.$API_URL).then(online => {
          if (online) {
            this.isOffline = false;
          } else {
            this.isOffline = true;
          }
        });
      } else {
        this.isOffline = true;
      }
    },
    isReachable: function(url) {
      return fetch(url, { method: 'HEAD', mode: 'no-cors' }).then(function(resp) {
        return resp && (resp.ok || resp.type === 'opaque');
      });
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/features/route`, { params: { route: this.route } }).then(response => {
      this.features = response.data.features.reduce((acc, x) => {
        acc[x.path.replace(`${this.route}/`, '')] = x.isActive;

        return acc;
      }, {});
    });
    this.$axios.get(`${this.$API_URL}/user/applied-workshops`).then(response => {
      this.appliedEvents = response.data;
      try {
        let parsedEvents = JSON.parse(localStorage.getItem('favoritedEvents2020'));
        this.eventsFavorited = [...parsedEvents];
      } catch (_) {
        this.eventsFavorited = [];
      }

      this.eventCount = this.appliedEvents.length + this.eventsFavorited.length;
    });
  },
  mounted() {
    EventBus.$on('increment-navigation-number', () => this.eventCount++);
    EventBus.$on('decrement-navigation-number', () => this.eventCount--);

    window.addEventListener('online', this.handleConnection);
    window.addEventListener('offline', this.handleConnection);
    this.handleConnection();
  },
};
</script>

<style>
* {
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
}

a {
  text-decoration: none;
}

body {
  margin: 0;
  padding-bottom: 60px;
  overflow-x: hidden;
}

@media screen and (min-width: 1023px) {
  .layout-spacing {
    max-width: 1030px;
    margin-left: auto;
    margin-right: auto;
  }

  .layout-spacing-big {
    max-width: 1240px;
    margin-left: auto;
    margin-right: auto;
  }
}

#user-navigation {
  position: fixed;
  bottom: -2px;
  left: 0;
  width: 100%;
  background: #162426;
  filter: drop-shadow(10px -4px 4px rgba(10, 24, 27, 0.5));
  z-index: 999;
}

.nav-wrapper-app {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#user-navigation.blurred {
  filter: blur(10px);
}

.title {
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  line-height: 38px;
  margin-bottom: 40px;
  color: #ffffff;
}

.nav-container {
  display: flex;
  width: 100%;
  justify-content: space-around;
  padding: 17px 0;
}

.app-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

@media screen and (max-width: 1023px) {
  .app-link {
    flex-basis: 20%;
  }
}

.app-link span {
  font-size: 12px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.8);
}

.app-link img {
  width: 24px;
  height: 24px;
  margin-bottom: 10px;
}

.app-link.profile img {
  width: 18px;
}

.app-link.fly-talks img {
  width: 28px;
}

.app-link.router-link-exact-active img {
  filter: invert(65%) sepia(92%) saturate(358%) hue-rotate(122deg) brightness(92%) contrast(85%);
}

.app-link.router-link-exact-active span {
  color: #30cec2;
}

#user-navigation .app-link.schedule {
  position: relative;
}

#user-navigation .app-link.schedule .menu-schedule-number-icon {
  position: absolute;
  background-color: #30cec2;
  font-size: 10px;
  color: white;
  border-radius: 100%;
  font-variant-numeric: tabular-nums;
  text-align: center;
  width: 18px;
  height: 18px;
  opacity: 1;
  bottom: 35px;
  right: 10px;
}

.user-offline {
  position: fixed;
  bottom: 60px;
  padding: 5px 10px;
  background-color: #30cec2;
  color: white;
  font-weight: 700;
  text-align: center;
  z-index: 1000;
}

.user-offline span {
  position: absolute;
  right: 5px;
  top: 5px;
  transform: scaleX(1.5);
}

.navbar-logo {
  cursor: pointer;
  display: none;
}

#user-app .app-modal {
  position: relative;
  z-index: 9000;
  background: rgba(10, 24, 27, 0.8);
}

#user-app .app-modal,
#user-app .backdrop {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

#user-app .app-modal .modal-content {
  filter: none;
  background-color: #111f22;
  border-radius: 25px;
  padding: 48px 24px;
  box-sizing: border-box;
  z-index: 2;
  color: white;
}

#user-app .app-modal .modal-content .header .title-with-close {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
}

#user-app .app-modal .modal-content .header .title-with-close .close-mobile {
  display: none;
}

#user-app .app-modal .modal-content .header .title-with-close .title {
  font-size: 24px;
  font-weight: 700;
}

#user-app .app-modal .modal-content .header .title-with-close .close {
  position: relative;
  width: 24px;
  height: 24px;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

#user-app .app-modal .modal-content .header .title-with-close .close:hover {
  cursor: pointer;
}

#user-app .app-modal .modal-content .header .title-with-close .close::before,
#user-app .app-modal .modal-content .header .title-with-close .close::after {
  content: '';
  position: absolute;
  width: 4px;
  height: 24px;
  background-color: white;
  border-radius: 2px;
  top: 0;
}

#user-app .app-modal .modal-content .header .title-with-close .close::before {
  transform: rotate(45deg);
}

#user-app .app-modal .modal-content .header .title-with-close .close::after {
  transform: rotate(-45deg);
}

#user-app .app-modal .modal-content .header .header-separator {
  border: none;
  border-bottom: 1px solid white;
}

@media screen and (max-width: 700px) {
  #user-app .app-modal .modal-content {
    border-radius: 0;
    width: 100%;
    min-height: 100%;
  }

  #user-app .app-modal .modal-content .header .title-with-close {
    justify-content: flex-start;
    margin-bottom: 0;
  }

  #user-app .app-modal .modal-content .header .title-with-close .close-mobile {
    display: block;
    margin-right: 20px;
  }

  #user-app .modal .modal-content .header .title-with-close .close-mobile:hover {
    cursor: pointer;
  }

  #user-app .app-modal .modal-content .header .title-with-close .close,
  #user-app .app-modal .modal-content .header .header-separator {
    display: none;
  }
}

@media screen and (min-width: 1024px) {
  #user-navigation {
    box-sizing: border-box;
    top: 0;
    bottom: unset;
    align-items: center;
    justify-content: space-between;
    padding: 16px 92px;
  }

  .navbar-logo {
    display: unset;
    height: 48px;
  }

  .nav-container {
    width: auto;
  }

  .app-link {
    margin-right: 25px;
    flex-direction: row;
    justify-content: center;
    width: auto;
  }

  .app-link:hover span {
    color: #30cec2;
  }

  .app-link:hover img {
    filter: invert(65%) sepia(92%) saturate(358%) hue-rotate(122deg) brightness(92%) contrast(85%);
  }

  .app-link span {
    font-size: 14px;
    line-height: 22px;
    margin-left: 15px;
    transition: color 0.2s ease-in-out;
  }

  .app-link img {
    width: 21px;
    height: 21px;
    transition: filter 0.2s ease-in-out;
  }

  #user-navigation .app-link.schedule .menu-schedule-number-icon {
    bottom: 30px;
    right: unset;
    left: 11px;
    width: 20px;
    height: 20px;
    font-size: 11px;
  }

  .app-link.schedule.router-link-exact-active .menu-schedule-number-icon {
    bottom: 25px !important;
  }

  .app-link:nth-of-type(1) img,
  .app-link:nth-of-type(2) img {
    margin-top: 9px;
  }

  .app-link:nth-of-type(3) img {
    margin-top: 10px;
  }

  .app-link:nth-of-type(4) img,
  .app-link:nth-of-type(5) img {
    margin-top: 11px;
  }

  @media screen and (min-width: 1440px) {
    .app-link {
      margin-right: 75px;
    }

    .app-link span {
      font-size: 16px;
      line-height: 24px;
    }

    .app-link img {
      width: 22px;
      height: 22px;
    }

    #user-navigation .app-link.schedule .menu-schedule-number-icon {
      bottom: 38px;
      left: 11px;
      width: 22px;
      height: 22px;
      font-size: 13px;
    }

    .app-link.schedule.router-link-exact-active .menu-schedule-number-icon {
      bottom: 34px !important;
    }

    .app-link:nth-of-type(1) img,
    .app-link:nth-of-type(3) img {
      margin-top: 11px;
    }

    .app-link:nth-of-type(2) img {
      margin-top: 10px;
    }
  }
}
</style>
